module.exports = "<div class=\"page-header\"\r\n     filter-color=\"orange\">\r\n  <div class=\"page-header-image\"\r\n       style=\"background-image:url('/assets/img/background8.jpg')\"></div>\r\n  <div class=\"section section-signup\">\r\n    <div class=\"container\">\r\n      <div class=\"row\">\r\n        <div class=\"card card-signup\"\r\n             data-background-color=\"orange\">\r\n          <h5>{{vm.message}}</h5>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/confirmRegistration/confirmRegistration.html
// module id = 625
// module chunks = 0